import { GlIcon } from '@gitlab/ui';
export default {
    name: 'ApprovedIcon',
    components: {
        GlIcon
    },
    props: {
        isApproved: {
            type: Boolean,
            required: true
        }
    }
};
